import { render, staticRenderFns } from "./SimpleProduct.vue?vue&type=template&id=1b0020c0&"
import script from "./SimpleProduct.vue?vue&type=script&lang=js&"
export * from "./SimpleProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports